// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class LoadMoreButton extends Vue {
  @Prop({ default: false })
  public isLoading!: boolean;
}
